import React, { createContext, ReactNode, useContext, useState } from "react";
import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import SettingsChangeDefaultBranchProvider from "./SettingsChangeDefaultBranchProvider";
import { DefaultBranch } from "../../../model/settings/SettingsChangeDefaultBranchModel";
import { useDispatch } from "react-redux";
import { setBranchListScreenName } from "../../../libraries/state_reducers/branch/BranchListReducer";
import { addModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { routeName as routeNameSettingsChangeDefaultBranch } from "../../../screens/settings/change_default_branch/SettingsChangeDefaultBranchScreen";
import Loader from "../../../widget/common/ui/Loader";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";

type SettingsChangeDefaultBranchTypes = {
  branchDefaultInfo?: DefaultBranch;
  getBranchDefaulInfo: () => void;
  onClickChange: () => void;
  setDefaultBranch: (branchId: string) => void;
};

const SettingsChangeDefaultBranchContext = createContext<
  SettingsChangeDefaultBranchTypes | undefined
>(undefined);

export const SettingsChangeDefaultBranchContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();

  const [branchDefaultInfo, setBranchDefaultInfo] = useState<
    DefaultBranch | undefined
  >(undefined);

  const getBranchDefaulInfo = async () => {
    const settingsBranchDefaultDetailsModel =
      await SettingsChangeDefaultBranchProvider.getBranchDefaulInfoAPI();
    if (settingsBranchDefaultDetailsModel !== null) {
      const defaultBranchResult: DefaultBranch | null =
        settingsBranchDefaultDetailsModel?.result?.default_branch!;

      setBranchDefaultInfo(defaultBranchResult);
    }
  };

  const setDefaultBranch = async (branchId: string = "") => {
    if (UtilityHelper.isNotEmpty(branchId)) {
      Loader.modal();

      const status: boolean =
        await SettingsChangeDefaultBranchProvider.updateDefaultBranchAPI(
          branchId
        );
      if (status) {
        // SET NEW DEFAULT BRANCH ID
        CacheStorage.saveValue(StorageKeys.branch_id, branchId);

        await getBranchDefaulInfo();
      }

      Loader.modal(false);
    }
  };

  const onClickChange = () => {
    dispatch(
      setBranchListScreenName({
        screenName: routeNameSettingsChangeDefaultBranch,
      })
    );
    dispatch(
      addModal({
        id: ModalKeys.list_choose_branch,
        title: AppTranslation.text("choose_preferred_branch"),
        screenMobileView: type !== 3,
      })
    );
  };

  return (
    <SettingsChangeDefaultBranchContext.Provider
      value={{
        branchDefaultInfo,
        getBranchDefaulInfo,
        onClickChange,
        setDefaultBranch,
      }}
    >
      {children}
    </SettingsChangeDefaultBranchContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const SettingsChangeDefaultBranchContextImport = () => {
  const context = useContext(SettingsChangeDefaultBranchContext);
  if (!context) {
    throw new Error(
      "SettingsChangeDefaultBranchContextImport must be used within a SettingsChangeDefaultBranchContextProvider"
    );
  }
  return context;
};
